var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5321 18.4755C19.6567 18.5985 19.8247 18.6672 19.9995 18.667C20.0165 18.667 20.0335 18.667 20.0491 18.6657C20.2413 18.6509 20.4178 18.5541 20.5334 18.4L24.5334 13.0668V13.0666C24.7542 12.7717 24.6941 12.3538 24.3993 12.1331C24.1044 11.9124 23.6865 11.9724 23.4658 12.2672L19.9241 16.99L17.9241 15.0226V15.0223C17.7987 14.8958 17.6277 14.8248 17.4493 14.8252C17.2712 14.8257 17.1004 14.8973 16.9757 15.0243C16.8507 15.1516 16.7817 15.3232 16.7844 15.5016C16.7868 15.6797 16.8607 15.8496 16.9893 15.9728L19.5321 18.4755Z",
    fill: "url(#paint0_linear_1743_15143)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9807 15.619L28.6664 13.7777V10.6667C28.6664 9.95937 28.3854 9.28126 27.8854 8.78103C27.3851 8.28103 26.707 8 25.9997 8H15.3334C14.626 8 13.9479 8.28103 13.4477 8.78103C12.9477 9.28125 12.6666 9.95937 12.6666 10.6667V13.7777L9.35234 15.619C9.14453 15.7344 8.97131 15.9034 8.85078 16.1083C8.73024 16.3134 8.66663 16.5467 8.66663 16.7846V28C8.66663 29.061 9.08805 30.0784 9.83828 30.8284C10.5883 31.5786 11.6057 32 12.6666 32H28.6666C29.7275 32 30.745 31.5786 31.495 30.8284C32.2452 30.0784 32.6666 29.061 32.6666 28V16.7846C32.6666 16.5467 32.603 16.3134 32.4825 16.1083C32.3619 15.9034 32.1887 15.7344 31.9809 15.619H31.9807ZM29.113 19.8946L21.113 23.8946C20.832 24.035 20.501 24.035 20.2197 23.8946L12.2197 19.8946C11.9824 19.7761 11.8021 19.5683 11.7179 19.3168C11.634 19.0652 11.6534 18.7906 11.7717 18.5534C11.8902 18.3161 12.0981 18.1355 12.3496 18.0516C12.6012 17.9677 12.8757 17.9871 13.113 18.1054L13.9996 18.5489V10.6666C14.0001 10.3131 14.1407 9.97423 14.3907 9.72423C14.6407 9.47422 14.9795 9.3336 15.3331 9.33315H25.9999H25.9997C26.3533 9.3336 26.6921 9.47422 26.9421 9.72423C27.1921 9.97423 27.3327 10.3131 27.3332 10.6666V18.5489L28.2198 18.1056V18.1054C28.4571 17.9871 28.7316 17.9677 28.9832 18.0516C29.2348 18.1355 29.4426 18.3161 29.5611 18.5534C29.6794 18.7907 29.6988 19.0652 29.6149 19.3168C29.5307 19.5683 29.3504 19.7761 29.1131 19.8946H29.113Z",
    fill: "url(#paint1_linear_1743_15143)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1743_15143",
    x1: 16.7843,
    y1: 15.3335,
    x2: 24.6665,
    y2: 15.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1743_15143",
    x1: 8.66663,
    y1: 20,
    x2: 32.6666,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.ba6eff0ccc14f30d79169972f8be3a0e.svg";
export { ForwardRef as ReactComponent };